import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { BbCloseIcon } from '../../../blackbook-components/quarks/icons';
import blackDialogImage from '../../../assets/images/blackdialog.png';
import { useTrack } from '../../../services/hooks/useTrack';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  z-index: 9999999999;
`;

const Modal = styled.div`
  border-radius: 20px;
  overflow: hidden;
  width: 80%;
  max-width: 400px;
  height: 50%;
  min-height: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const Content = styled.div`
  flex: 1;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const CloseContainer = styled.div`
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 17px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: white;
`;

const ButtonContainer = styled.div`
  width: 100%;
  padding: 20px;
  padding-bottom: 25px;
  box-sizing: border-box;
`;

const YellowButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 100px;
  border: 1px solid #FCDE17;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Open Sans', sans-serif;

  &:hover {
    border-color: #ECA511;
    opacity: 0.8;
  }

  &:active {
    opacity: 0.7;
  }
`;

const YellowButtonText = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: #FCDE17;
`;

export const BlackFridayDialog = ({ isVisible, onClose }) => {
  const { trackEvent } = useTrack();
  const history = useHistory();

  const handleAssineAgora = () => {
    history.push('/?c=BLACK50');
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isVisible) return null;

  return (
    <Overlay isVisible={isVisible} onClick={handleOverlayClick}>
      <Modal>
        <BackgroundImage src={blackDialogImage} alt="Black Friday Dialog" />
        <CloseContainer onClick={handleClose}>
          <CloseButton type="button">
            <BbCloseIcon />
          </CloseButton>
        </CloseContainer>
        <Content>
          <ButtonContainer>
            <YellowButton onClick={handleAssineAgora} type="button">
              <YellowButtonText>Assine agora</YellowButtonText>
            </YellowButton>
          </ButtonContainer>
        </Content>
      </Modal>
    </Overlay>
  );
};

